import { useQuery } from 'react-query';
import useContentfulLocale from 'components/useContentfulLocale';
import { segregateClientLists } from '../helpers';
import getHomeClientList from '../../../services/getHomeClientList';

export const useGetClientLists = clientId => {
  const ctfLocaleFilter = useContentfulLocale();

  const { data, status } = useQuery(
    clientId && ['client-lists', clientId, ctfLocaleFilter],
    getHomeClientList,
  );

  const { aboveFeatureList = [], belowFeatureList = [] } = data
    ? segregateClientLists(data)
    : {};

  return {
    data: {
      aboveFeatureList,
      belowFeatureList,
    },
    status,
  };
};
